export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

export const DEFAULT_ZOOM = 3.2;

export const CONTROL_SIZE = 25;

export const EARTH_RADIUS = 6378.8;
